export default function once(fn) {
    function wrapper (...args) {
        if (fn === null) return;
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    }
    Object.assign(wrapper, fn)
    return wrapper
}



// WEBPACK FOOTER //
// ./~/async-es/internal/once.js